import { IKnmSearchFilter } from 'APIPackage/KnmSearchModule/interfaces/IKnmSearchFilter';
import { SYSTEM_DATE_FORMAT_FNS } from 'CorePackage/MainModule/constants/dateFormats';
import { IFederalLawSelectOption } from 'CorePackage/CatalogsModule/interfaces/IFederalLawSelectOption';
import { formatDate } from 'CorePackage/MainModule/common/formatDate';
import { KnmVersionsEnum } from 'APIPackage/KnmModule/enums/KnmVersionsEnum';

import { IKnmSearchInitFilter } from '../interfaces/IKnmSearchInitFilter';

export const knmSearchGetFilters = (value: Partial<IKnmSearchInitFilter>, isErknm: boolean): IKnmSearchFilter => {
  return {
    frguOrgName: value && value.frguOrgName ? value.frguOrgName : '',
    ervkOrgName: value && value.frguOrgName ? value.frguOrgName : '',
    prosecutorName: value && value.prosecutorName ? value.prosecutorName : '',
    subjectTypeCodes: value && value.subjectTypeCodes ? value.subjectTypeCodes.map(item => item.code) : [],
    knmType: value && value.knmType ? [value.knmType.name] : [],
    year: value && value.year ? value.year.map((item: { id: string; value: string; label: string }) => item.value) : [],
    supervisionName:
      value && value.supervisionName
        ? value.supervisionName.title || value.supervisionName.name || value.supervisionName.value
        : '',
    organizationName: value && value.organizationName ? value.organizationName : '',
    erpId: value && value.erpId ? value.erpId : '',
    inn: value && value.inn ? value.inn : '',
    ogrn: value && value.ogrn ? value.ogrn : '',
    status:
      value && value.status
        ? (isErknm && value.status.map(item => item.name)) ||
          value.status.reduce((dataStatuses: string[], status) => {
            status.generalsNames.forEach(item => {
              if (!dataStatuses.includes(item)) {
                dataStatuses.push(item);
              }
            });

            return dataStatuses;
          }, [])
        : [],
    startMonth: value && value.startMonth ? value.startMonth.value : '',
    fromDate: value && value.fromDate ? formatDate({ date: value.fromDate, dateFormat: SYSTEM_DATE_FORMAT_FNS }) : '',
    toDate: value && value.toDate ? formatDate({ date: value.toDate, dateFormat: SYSTEM_DATE_FORMAT_FNS }) : '',
    federalLaws:
      value && value.federalLaws
        ? value.federalLaws.map((item: IFederalLawSelectOption) => item.number || item.code || '')
        : [],
    version: isErknm ? KnmVersionsEnum.ERKNM : KnmVersionsEnum.ERP,
  };
};
